// focusManager.js

let lastFocusedElement = null;
const trappedEls = new Set();

export function trapFocus(rootEls) {
  if (!Array.isArray(rootEls)) {
    rootEls = [rootEls];
  }

  lastFocusedElement = document.activeElement;
  releaseFocus();

  const focusableSelectors = [
    'a[href]',
    'area[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'iframe',
    'object',
    'embed',
    '[contenteditable]',
    '[tabindex]:not([tabindex="-1"])',
  ];

  //   const focusableEls = rootEls
  //     .flatMap((el) => Array.from(el.querySelectorAll(focusableSelectors.join(', '))))
  //     .filter((el) => el.offsetParent !== null); // exclude hidden
  const focusableEls = rootEls
    .filter((el) => el) // remove nulls
    .flatMap((el) => Array.from(el.querySelectorAll(focusableSelectors.join(', '))))
    .filter((el) => el.offsetParent !== null); // exclude hidden

  // console.log(focusableEls);

  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];

  function handleKeyDown(e) {
    if (e.key !== 'Tab' || focusableEls.length === 0) return;

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableEl) {
        e.preventDefault();
        lastFocusableEl.focus();
      }
    } else {
      if (document.activeElement === lastFocusableEl) {
        e.preventDefault();
        firstFocusableEl.focus();
      }
    }
  }

  rootEls.forEach((el) => {
    el.addEventListener('keydown', handleKeyDown);
    el.__focusTrapHandler = handleKeyDown;
    trappedEls.add(el);
  });

  firstFocusableEl?.focus();
}

export function releaseFocus() {
  trappedEls.forEach((el) => {
    if (el && el.__focusTrapHandler) {
      el.removeEventListener('keydown', el.__focusTrapHandler);
      delete el.__focusTrapHandler;
    }
  });
  trappedEls.clear();

  if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
    lastFocusedElement.focus();
  }

  lastFocusedElement = null;
}
